<template>
    <div class="row">
        <div class="col-md-3 col-sm-6">Запрошення -</div>
        <div class="col-md-2 col-sm-6 text-right click_requests" >
            <a target="_blank" :href="'/tendery?contragent_id=' + this.contragent.id + '&doc_type=1'">
                {{rating?.request_count}}
            </a>
        </div>
        <div class="w-100"></div>
        <div class="col-md-3 col-sm-6">Участь -</div>
        <div class="col-md-2 col-sm-6 text-right click_parts">
            <a target="_blank" :href="'/tendery?contragent_id=' + this.contragent.id + '&doc_type=2'">
                {{rating?.parts_count}}
            </a>
        </div>
        <div class="w-100"></div>
        <div class="col-md-3 col-sm-6">Перемога -</div>
        <div class="col-md-2 col-sm-6 text-right click_wins">
            <a target="_blank" :href="'/tendery?contragent_id=' + this.contragent.id + '&doc_type=3'">
                {{rating?.wins_count}}
            </a>
        </div>
    </div>
    
    
    <legend>Оцінки Комерційного:</legend>
    <table class="table table-bordered table-striped">
        <thead>
        
        <tr>
            <th class="text-center">Критерій</th>
            <th class="text-center">
                % Позитивних<br>
                <small>(від участі)</small>
            </th>
            <th class="text-center">
                % Негативних<br>
                <small>(від участі)</small>
            </th>
            <th class="text-center">
                % Оцінено<br>
                <small>(від участі)</small>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td>Відповідає техзавданню</td>
            <td class="text-center">{{rating?.tech_p}}</td>
            <td class="text-center">{{rating?._tech_p}}</td>
            <td class="text-center">{{rating?.tech_r_p}}</td>
        
        </tr>
        <tr>
            <td>Надана вся інформація</td>
            <td class="text-center">{{rating?.info_full_p}}</td>
            <td class="text-center">{{rating?._info_full_p}}</td>
            <td class="text-center">{{rating?.info_full_r_p}}</td>
        
        </tr>
        <tr>
            <td>Сумлінно приймав участь</td>
            <td class="text-center">{{rating?.honesty_p}}</td>
            <td class="text-center">{{rating?._honesty_p}}</td>
            <td class="text-center">{{rating?.honesty_r_p}}</td>
        
        </tr>
        
        </tbody>
    </table>
    
    
    <legend>Оцінки Аудита:</legend>
    <table class="table table-bordered table-striped">
        <thead>
        
        <tr>
            <th class="text-center">Критерій</th>
            <th class="text-center">
                % Позитивних<br>
                <small>(від перемог)</small>
            </th>
            <th class="text-center">
                % Негативних<br>
                <small>(від перемог)</small>
            </th>
            <th class="text-center">
                % Оцінено<br>
                <small>(від перемог)</small>
            </th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td>Умови договору відповідають заявці</td>
            <td class="text-center">{{rating?.contract_is_responsible_p}}</td>
            <td class="text-center">{{rating?._contract_is_responsible_p}}</td>
            <td class="text-center">{{rating?.contract_is_responsible_r_p}} </td>
        
        </tr>
        <tr>
            <td>Постачання виконано вчасно</td>
            <td class="text-center">{{rating?.supply_is_responsible_p}} </td>
            <td class="text-center">{{rating?._supply_is_responsible_p}} </td>
            <td class="text-center">{{rating?.supply_is_responsible_r_p}}</td>
        
        </tr>
        <tr>
            <td>Якість відповідає техзавданню</td>
            <td class="text-center">{{rating?.quality_is_responsible_p}} </td>
            <td class="text-center">{{rating?._quality_is_responsible_p}}</td>
            <td class="text-center">{{rating?.quality_is_responsible_r_p}}</td>
        </tr>
        </tbody>
    </table>
    
</template>

<script>
export default {
    name: "cont_stata",
    props : {
        contragent : {
            type : Object,
            required : true,
        }
    },
    
    data() {
        return {
            "rating" : {}
        }
    },
    
    created() {
        this.loadRating();
    },
    
    methods : {
        async loadRating() {
            this.is_load = true;
            this.rating = [];
            
            await api.get('/tenders/sales/tenders/contragents/' + parseInt(this.contragent.id) + '/rating').then(({data}) => {
                this.is_load = false;
                if(data.status === "operation_success") {
                    this.rating = data.data;
                    
                }
            }).catch(e => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            })
        }
    }
}
</script>


<style scoped>

</style>